export default __webpack_public_path__ + "static/media/Pragmatic.2724b5bd.jpg";